export default {
  // only one video track can be published at the same time
  filterVideoTrack() {
    this.localTracks = this.localTracks.filter(item => item.trackMediaType !== 'video');

    if (!this.constraints.screen) {
      const track = this.videoEffect === 'none' ? this.localVideoTrack : this.localVbackgroundTrack;

      // Skip when the track is null (e.g. camera off) to avoid a failed publish.
      if (track) {
        this.localTracks.push(track);
      }
    }
  }
}

